import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DollarSign, Star } from "lucide-react";
import { api } from "../lib/api";
import { PhotographerCard } from "../components/PhotographerCard";
import { SectionHeading } from "../components/SectionHeading";
import { useSettings } from "../context/SettingsContext";

export default function PhotographerDirectory() {
  const [photographers, setPhotographers] = useState(null);
  const { settings } = useSettings();

  useEffect(() => {
    api.get("/photographers").then(({ data }) => setPhotographers(data));
  }, []);

  return (
    <div data-testid="photographer-directory-page">
      <section className="bg-midnight-black py-16 text-center">
        <p className="text-stranger-orange text-xs font-bold tracking-[0.25em] uppercase mb-3">Official Stranger Sessions Photographers</p>
        <h1 className="text-clean-white font-extrabold uppercase tracking-tight text-3xl sm:text-5xl max-w-2xl mx-auto px-5">Meet the Photographers Behind Every Session</h1>
        <Link to="/photographers/join" data-testid="directory-become-photographer-link" className="inline-block mt-8 text-stranger-orange font-bold tracking-wide text-sm hover:underline">
          Are you a photographer? Host your own Stranger Session →
        </Link>
      </section>

      <section className="bg-clean-white py-20">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <SectionHeading eyebrow="Verified" title="Official Stranger Sessions Photographers" align="left" />
          {photographers === null ? (
            <p className="text-center font-medium text-midnight-black/60" data-testid="photographers-loading">Loading photographers...</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-testid="photographers-grid">
              {photographers.map((p) => (
                <PhotographerCard key={p.id} photographer={p} />
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="bg-midnight-black py-20" data-testid="photographer-pricing-featured-section">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 md:grid-cols-2 gap-10">
          <div className="border border-white/15 rounded-2xl p-8" data-testid="photographer-pricing-block">
            <DollarSign className="w-8 h-8 text-stranger-orange mb-4" />
            <h3 className="text-clean-white font-extrabold uppercase text-xl mb-3">Pricing for Photographers</h3>
            <p className="text-clean-white/70 font-medium mb-5">
              No subscriptions, no sign-up fees. Just a simple ${settings?.default_photographer_booking_fee ?? 10} platform booking fee per session you host — you set your own session price and keep every dollar of it.
            </p>
            <Link to="/photographers/join" data-testid="pricing-learn-more-link" className="text-stranger-orange font-bold tracking-wide text-sm hover:underline">
              See how it works →
            </Link>
          </div>
          <div className="border border-white/15 rounded-2xl p-8" data-testid="featured-spots-block">
            <Star className="w-8 h-8 text-stranger-orange mb-4" />
            <h3 className="text-clean-white font-extrabold uppercase text-xl mb-3">Featured Photographer Spots Available</h3>
            <p className="text-clean-white/70 font-medium mb-5">
              Get your sessions in front of more Strangers with a featured spot on our homepage. Limited spots available.
            </p>
            <Link to="/contact" data-testid="featured-spots-contact-link">
              <button className="bg-stranger-orange text-clean-white font-bold tracking-widest text-xs px-6 py-3 rounded-full hover:bg-orange-600 transition-colors">
                CONTACT US FOR DETAILS
              </button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
